import { Grid } from '@mairistem/composants';
import { formatMontant } from '@mairistem/finances-utils';
import React from 'react';
import type PanelProps from '../../../interfaces/simulation/panelProps';
import { getSoldeClass } from '../../../utils/simulation/panel';

const BalanceFonctionnement = ({ data }: PanelProps) => {
	const solde =
		(data?.recetteFonctionnement ?? 0) - (data?.depenseFonctionnement ?? 0);
	const soldeClass = getSoldeClass(solde);
	return (
		<Grid>
			<Grid.Row>
				<Grid.Column className="bold indicateurTitle">
					Fonctionnement
				</Grid.Column>
			</Grid.Row>
			<Grid.Row stretched>
				<Grid.Column width={10}>
					<div>Dépense</div>
					<div>Recette</div>
				</Grid.Column>
				<Grid.Column width={6} textAlign="right">
					<div data-testid="depenseFonctionnement">
						{formatMontant(data?.depenseFonctionnement ?? 0)}
					</div>
					<div data-testid="recetteFonctionnement">
						{formatMontant(data?.recetteFonctionnement ?? 0)}
					</div>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className={soldeClass?.join(' ')}>
				<Grid.Column width={10}> Solde </Grid.Column>
				<Grid.Column
					width={6}
					textAlign="right"
					data-testid="soldeFonctionnement"
				>
					{formatMontant(solde)}
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

export default BalanceFonctionnement;
